<template>
    <div class="photo-input">
        <div
            class="photo-input__field"
            role="button"
            :class="{ 'photo-input__field--empty': !photo && !src }"
            :style="fieldSizeStyle"
            @click="onFieldClick"
        >
            <div class="photo-input__picture">
                <img v-if="photo || src" :src="src" class="photo-input__img" />
                <!-- <img
                    v-else
                    src="@speechki-frontend/shared/assets/img/account-edit-avatar-empty.svg"
                    class="photo-input__img photo-input__img--empty"
                /> -->
            </div>
            <div class="photo-input__controls">
                <label v-if="photo || src" class="photo-input__button" :for="inputId">
                    <PhotoInputIcon name="edit" />
                    <div class="photo-input__tooltip" :style="tooltipFontSizeStyle">
                        Заменить фото
                    </div>
                </label>
                <button
                    v-if="!noDelete && (photo || src)"
                    class="photo-input__button photo-input__button"
                    type="button"
                    @click.stop="deletePhoto"
                >
                    <PhotoInputIcon name="delete" />
                    <div class="photo-input__tooltip" :style="tooltipFontSizeStyle">
                        Удалить фото
                    </div>
                </button>
                <label
                    v-if="!photo && !src"
                    :for="inputId"
                    class="photo-input__button photo-input__button"
                    type="button"
                    @click.stop="deletePhoto"
                >
                    <PhotoInputIcon name="upload" />
                    <div class="photo-input__tooltip" :style="tooltipFontSizeStyle">
                        Загрузить фото
                    </div>
                </label>
            </div>
        </div>
        <input
            :id="inputId"
            ref="input"
            :name="name"
            type="file"
            class="photo-input__file-input"
            accept="image/jpeg,image/png"
            @change="setFile"
        />
        <div v-if="!noFilename && file && file.name" class="photo-input__filename">
            {{ file.name }}
        </div>
    </div>
</template>

<script>
// @TODO adapt for FormField

import PhotoInputIcon from './PhotoInputIcon';

import { makeid } from '@speechki-frontend/shared/helpers/functions';

export default {
    name: 'PhotoInput',
    components: {
        PhotoInputIcon
    },
    props: {
        photo: {
            default: null
        },
        noDelete: {
            type: Boolean,
            default: false
        },
        noFilename: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: ''
        },
        size: {
            type: [String, Number],
            default: 100
        }
    },
    data() {
        return {
            file: null,
            reader: new FileReader(),
            src: null,
            inputId: makeid()
        };
    },
    computed: {
        tooltipFontSizeStyle() {
            return parseInt(this.size) > 150
                ? { 'font-size': '12px', 'line-height': '17px', bottom: '-22px' }
                : {};
        },
        fieldSizeStyle() {
            let size = parseInt(this.size);
            return { width: size + 'px', height: size + 'px' };
        }
    },
    watch: {
        photo: {
            immediate: true,
            handler() {
                if (this.photo && typeof this.photo !== 'object') {
                    this.src = this.photo;
                }
            }
        }
    },
    mounted() {
        this.reader.onload = event => {
            this.src = event.target.result;
        };
    },
    methods: {
        setFile(event) {
            if (!event.target.files.length) return;
            this.file = event.target.files[0];
            this.reader.readAsDataURL(this.file);
            this.$emit('selected', this.file);
        },
        deletePhoto() {
            this.src = null;
            this.file = null;
            this.$emit('deleted');
        },
        onFieldClick() {
            if (this.photo || this.src) return;

            this.$refs.input.click();
        }
    }
};
</script>

<style lang="scss" src="./PhotoInput.scss"></style>
